import React from 'react';
import { createPortal } from 'react-dom';
import { Box } from './core';
import { ModalContext } from '../context/ModalContext';

export const FullScreenModal = ({
  children,
}: {
  children: any;
}): JSX.Element | null => {
  const modalElement = document.getElementById('modal') as HTMLElement;
  const { modal } = React.useContext(ModalContext);
  if (!modal || !modalElement) return null;
  return createPortal(
    <Box variant="boxes.fullscreen" sx={{ zIndex: 500 }}>
      <Box variant="boxes.fullscreenMobileFill">{children}</Box>
    </Box>,
    modalElement
  );
};
